import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RsvpQuestions from './RsvpQuestions';
import GuestRsvp from './GuestRsvp';
import GuestRsvpSummary from './GuestRsvpSummary';


function EventRsvp({ event, selector, success, mealOptionsById, forPreview, wedding, eventIndex }) {
  return (
    <Fragment>
      {event && (
        <div className="entity-section-description event-section-description">
          {event.collect_rsvps ? (
            <div className="collecting-rsvps">
              {!success ? (
                <div>
                  {selector('guests') && (
                    <GuestRsvp
                      fields={selector('guests')}
                      eventId={event.id}
                      eventIndex={eventIndex}
                      mealOptions={event.meal_options.map(mealOption => ({ value: mealOption.id, title: _.capitalize(mealOption.name) }))}
                      selector={selector}
                      forPreview={forPreview}
                    />
                  )}
                  {event.rsvp_questions.length > 0 && (
                    <RsvpQuestions questions={event.rsvp_questions} />
                  )}
                </div>
              ) : (
                <GuestRsvpSummary
                  selector={selector}
                  mealOptionsById={mealOptionsById}
                  event={event}
                  eventIndex={eventIndex}
                />
              )}
            </div>
          ) : (
            <div className="not-collecting-rsvps">
              <h4>You are invited to the {event.name}!</h4>
              <p>{wedding.owner_first_name} &amp; {wedding.partner_first_name} are not collecting online RSVPs for this event, so just take note of the necessary details if you&#39;re attending!</p>
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
}

EventRsvp.propTypes = {
  event: PropTypes.shape({}),
  selector: PropTypes.func,
  success: PropTypes.bool,
  mealOptionsById: PropTypes.shape({}),
  forPreview: PropTypes.bool,
  wedding: PropTypes.shape({}),
  eventIndex: PropTypes.number,
};

export default EventRsvp;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/rsvp/RsvpForm/EventRsvp.jsx